<script setup>
import { reactive, computed } from 'vue';
import { useStore } from 'vuex';
import apiManager from '@/api';
import BigModal from './BigModal.vue';

defineProps({
  id: String, // eventId?
  showQuestion: Boolean,
  success: Object, // { value }
});

const successTimeout = 10000;

const success = reactive({
  value: false,
  message: '',
  timeout: successTimeout,
});

const error = reactive({
  value: false,
  message: '',
  timeout: successTimeout,
});

const emit = defineEmits(['close']);

const store = useStore();

const solutions = computed(() => store.state.solutions.solutions);

const fleetSizes = computed(() => store.state.fleetSizes.fleetSizes);

const requestMoreInfo = async (inputs) => { // yes this also uses the register api
  try {
    await apiManager.events.register(inputs);
    success.message = 'Thank you! A representative from Ford Pro will be in touch soon.';
    success.value = true;
  } catch (e) {
    if (e.response.status === 409) {
      success.message = 'Thank you! A representative from Ford Pro will be in touch soon.';
      success.value = true;
    } else {
      error.message = 'We are very sorry. Something went wrong, try again later.';
      error.value = true;
    }
  } finally {
    setTimeout(() => {
      emit('close');
    }, successTimeout);
  }
};

</script>
<template>
  <big-modal
    @validated="requestMoreInfo"
    @close="() => emit('close')"
    title="Get More Information"
    subTitle="
      Complete the form below to stay on top
      of our ongoing Ford Pro™ news and updates.
    "
    :success="success"
    :id="id"
    :fleetSizes="fleetSizes"
    :solutions="solutions"
    interested-text="I’d like to stay in the know about the latest news,
      products, and innovative solutions from Ford Pro."
    outside-text="Keep me posted about future in-person events, webinars,
    and on-demand opportunities to learn more about Ford Pro Solutions."
    :showQuestion="showQuestion" />
</template>
